module.exports = __webpack_public_path__ + "static/media/gapahuk.d7ce9d7d.jpg";